import { Product } from '../../types/product';

export const SET_PRODUCTS = 'SET_PRODUCTS';

export class SetProducts {
  readonly type = SET_PRODUCTS;
  readonly payload: Product[];

  constructor(types: Product[]) {
    this.payload = types;
  }
}

export type Action = SetProducts;
